import React from "react";
import styles from "./styles.module.css";
import { timeAgo } from "../Marque/time";
import { useNavigate } from "react-router-dom";
const RandomCard = ({ post }) => {
  const navigate = useNavigate();
  const someDate = new Date(post?.createdAt);

  const clickHandler = () => {
    navigate(`/post/${post._id}`, { state: post });
  };

  return (
    <div className={styles.card} onClick={clickHandler}>
      <div className={styles.cardImage}>
        <img src={post?.images?.[0]} alt="Posts" />
      </div>
      <div className={styles.cardText}>
        <h6>
          {post?.title?.length > 30
            ? `${post?.title?.slice(0, 30)}...`
            : post?.title}
        </h6>
        <span>{post?.author}</span>
        <span>{timeAgo(someDate)}</span>
      </div>
    </div>
  );
};

export default RandomCard;
